/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './speciality-vitals.reducer';

export const SpecialityVitals = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const specialityVitalsList = useAppSelector(state => state.specialityVitals.entities);
  const loading = useAppSelector(state => state.specialityVitals.loading);
  const totalItems = useAppSelector(state => state.specialityVitals.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="speciality-vitals-heading" data-cy="SpecialityVitalsHeading">
        <Translate contentKey="tinyMedicRestApp.specialityVitals.home.title">Speciality Vitals</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.specialityVitals.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/speciality-vitals/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.specialityVitals.home.createLabel">Create new Speciality Vitals</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.specialityVitals.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {specialityVitalsList && specialityVitalsList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('title')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.title">Title</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('title')} />
                </th>
                <th className="hand" onClick={sort('unitsOfMeasure')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.unitsOfMeasure">Units Of Measure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('unitsOfMeasure')} />
                </th>
                <th className="hand" onClick={sort('valueType')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.valueType">Value Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('valueType')} />
                </th>
                <th className="hand" onClick={sort('normalRangeLowerLimit')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.normalRangeLowerLimit">Normal Range Lower Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('normalRangeLowerLimit')} />
                </th>
                <th className="hand" onClick={sort('normalRangeUpperLimit')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.normalRangeUpperLimit">Normal Range Upper Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('normalRangeUpperLimit')} />
                </th>
                <th className="hand" onClick={sort('possibleRangeLowerLimit')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.possibleRangeLowerLimit">Possible Range Lower Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('possibleRangeLowerLimit')} />
                </th>
                <th className="hand" onClick={sort('possibleRangeUpperLimit')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.possibleRangeUpperLimit">Possible Range Upper Limit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('possibleRangeUpperLimit')} />
                </th>
                <th className="hand" onClick={sort('symptom')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.symptom">Symptom</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('symptom')} />
                </th>
                <th className="hand" onClick={sort('subSpeciality')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.subSpeciality">Sub Speciality</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('subSpeciality')} />
                </th>
                <th className="hand" onClick={sort('group')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.group">Group</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('group')} />
                </th>
                <th className="hand" onClick={sort('forAppointment')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.forAppointment">For Appointment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('forAppointment')} />
                </th>
                <th className="hand" onClick={sort('forPrescription')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.forPrescription">For Prescription</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('forPrescription')} />
                </th>
                <th className="hand" onClick={sort('subGroup')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.subGroup">Sub Group</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('subGroup')} />
                </th>
                <th className="hand" onClick={sort('country')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.country">Country</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('country')} />
                </th>
                <th className="hand" onClick={sort('sortOrder')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.sortOrder">Sort Order</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sortOrder')} />
                </th>
                <th className="hand" onClick={sort('groupOnly')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.groupOnly">Group Only</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('groupOnly')} />
                </th>
                <th className="hand" onClick={sort('vitalCode')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.vitalCode">Vital Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vitalCode')} />
                </th>
                <th className="hand" onClick={sort('config')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.config">Config</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('config')} />
                </th>
                <th className="hand" onClick={sort('entityType')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.entityType">Entity Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityType')} />
                </th>
                <th className="hand" onClick={sort('entityId')}>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.entityId">Entity Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityId')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.parent">Parent</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.specialty">Specialty</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.specialityVitals.language">Language</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {specialityVitalsList.map((specialityVitals, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/speciality-vitals/${specialityVitals.id}`} color="link" size="sm">
                      {specialityVitals.id}
                    </Button>
                  </td>
                  <td>{specialityVitals.active ? 'true' : 'false'}</td>
                  <td>{specialityVitals.lastUpdated}</td>
                  <td>{specialityVitals.timestampEntry}</td>
                  <td>{specialityVitals.microSec}</td>
                  <td>{specialityVitals.cursor}</td>
                  <td>{specialityVitals.title}</td>
                  <td>{specialityVitals.unitsOfMeasure}</td>
                  <td>{specialityVitals.valueType}</td>
                  <td>{specialityVitals.normalRangeLowerLimit}</td>
                  <td>{specialityVitals.normalRangeUpperLimit}</td>
                  <td>{specialityVitals.possibleRangeLowerLimit}</td>
                  <td>{specialityVitals.possibleRangeUpperLimit}</td>
                  <td>{specialityVitals.symptom}</td>
                  <td>{specialityVitals.subSpeciality}</td>
                  <td>{specialityVitals.group}</td>
                  <td>{specialityVitals.forAppointment ? 'true' : 'false'}</td>
                  <td>{specialityVitals.forPrescription ? 'true' : 'false'}</td>
                  <td>{specialityVitals.subGroup}</td>
                  <td>{specialityVitals.country}</td>
                  <td>{specialityVitals.sortOrder}</td>
                  <td>{specialityVitals.groupOnly ? 'true' : 'false'}</td>
                  <td>{specialityVitals.vitalCode}</td>
                  <td>{specialityVitals.config}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.EntityType.${specialityVitals.entityType}`} />
                  </td>
                  <td>{specialityVitals.entityId}</td>
                  <td>
                    {specialityVitals.parent ? (
                      <Link to={`/speciality-vitals/${specialityVitals.parent.id}`}>{specialityVitals.parent.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {specialityVitals.specialty ? (
                      <Link to={`/especialty/${specialityVitals.specialty.id}`}>{specialityVitals.specialty.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {specialityVitals.language ? (
                      <Link to={`/language/${specialityVitals.language.id}`}>{specialityVitals.language.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/speciality-vitals/${specialityVitals.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/speciality-vitals/${specialityVitals.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/speciality-vitals/${specialityVitals.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.specialityVitals.home.notFound">No Speciality Vitals found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={specialityVitalsList && specialityVitalsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SpecialityVitals;
